import React, { useEffect, useState } from 'react';

import { FormCampanha } from '../../components/FormCampanha';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function EditarCampanhaPage(props) {

    const [campanha, setCampanha] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingCampanha, setErrorGettingCampanha] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idCampanha] = useState(props.match.params.id)

    const getCampanha = async (id) => {
        setIsLoading(true);

        try {
            const response = await api.get(`campanha/${id}`)
            
            setCampanha({
                'id': response.data.id,
                'nome': response.data.nome,
                'dataInicio': response.data.dataInicio,
                'dataFim': response.data.dataFim,
                'dataEntrega': response.data.dataEntrega,  
                'ativo': response.data.ativo,    
                'muda': response.data.muda, 
                'qtde_mudas_rural': response.data.qtde_mudas_rural,
                'qtde_mudas_urbana': response.data.qtde_mudas_urbana,
                'endereco': response.data.endereco,
                'validarEnderecoPessoa' : response.data.validarEnderecoPessoa,
            })

            setErrorGettingCampanha(false)
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingCampanha(true)
        }

        setIsLoading(false);
    }

    useEffect(() => {
        getCampanha(idCampanha)
    }, [])

    return (
        <>
            <MenuMain >
                {
                    errorGettingCampanha ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            retrieveFunction={() => getCampanha(idCampanha)}
                            isLoading={isLoading}
                        />
                        :
                        <FormCampanha
                            defaultValues={campanha}
                            isEditing={true}
                            isLoading={isLoading}
                        />
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}
